import { NetworkStatus, useQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router';

import { CompanyRelationshipMutations } from './relationship_mutations_container';
import { InfiniteScroll } from '../../components/infinitescroll';
import {
  CompanyRelationshipsListQuery as CompanyRelationshipsListQueryResult,
  CompanyRelationshipsListQueryVariables,
  getNodes,
  PAGINATION_PAGE_SIZE,
  loadMoreFromConnection,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { RelationshipList, RelationshipListDataProps } from '../components/relationship_list';
import { companyRelationshipsListQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyRelationshipsListQueryResult,
  RelationshipListDataProps,
  CompanyRelationshipsListQueryVariables
> {}

export const RelationshipsContainer = () => {
  const { company_id } = useParams() as { company_id: string };

  const result = useQuery<CompanyRelationshipsListQueryResult, CompanyRelationshipsListQueryVariables>(
    companyRelationshipsListQuery,
    {
      fetchPolicy: 'cache-and-network',
      variables: { companyId: company_id, limit: PAGINATION_PAGE_SIZE },
    },
  );

  return (
    <React.Fragment>
      <CompanyRelationshipMutations>
        {({ deleteCompanyRelationship, updateCompanyRelationshipSignupStatus }) => (
          <LoadingContainer
            result={result}
            options={{
              showLoadingPlaceholder: ({ networkStatus, loading }) => {
                const isFetchingMore = networkStatus === 3;
                return isFetchingMore ? false : loading;
              },
            }}
            mapData={({ data }) => ({
              data: {
                companyRelationships: getNodes(data.companyRelationships),
                company_id,
              },
            })}>
            {({ data }) => (
              <InfiniteScroll
                triggerOnWindow={false}
                loadMoreEntries={() =>
                  loadMoreFromConnection(companyRelationshipsListQuery, result, ['companyRelationships'])
                }>
                <RelationshipList
                  data={data}
                  deleteCompanyRelationship={deleteCompanyRelationship}
                  updateCompanyRelationshipSignupStatus={updateCompanyRelationshipSignupStatus}
                  hasMoreEntries={result.data?.companyRelationships?.pageInfo.hasNextPage === true}
                  isLoadingMoreEntries={result.networkStatus === NetworkStatus.fetchMore}
                  loadMoreEntries={() =>
                    loadMoreFromConnection(companyRelationshipsListQuery, result, ['companyRelationships'])
                  }
                />
              </InfiniteScroll>
            )}
          </LoadingContainer>
        )}
      </CompanyRelationshipMutations>
    </React.Fragment>
  );
};
